import { FullTask, loaders } from 'entities';

import { useProjectProfile } from '../context';

import { quickContext } from 'utils/react';
import { useCallback, useMemo } from 'react';

type TaskModalProps = {
  taskId: string | null;
  close: () => void;
  // onTask?: (data: FullTask) => void;
};

export const { useTaskModal, withTaskModalContext } = quickContext(
  'taskModal',
  ({ taskId, close }: TaskModalProps) => {
    const { updateProject, project } = useProjectProfile();

    const task = project.tasks.find((task) => task.id === taskId) as FullTask;

    const updateTask = useCallback(
      (taskUpdate: Partial<FullTask> | ((old: FullTask) => FullTask)) => {
        const updater =
          typeof taskUpdate === 'function'
            ? taskUpdate
            : (t: FullTask) => ({ ...t, ...taskUpdate });

        updateProject((old) => ({
          ...old,
          tasks: old.tasks.map((t) => (t.id === taskId ? updater(t as FullTask) : t)),
        }));
      },
      [taskId, updateProject],
    );

    const { errorOrLoading } = loaders.projects.findTask.use({
      params: {
        projectId: project.id,
        taskId: taskId!,
      },

      blockLoad: !taskId,

      onDataChange: updateTask,
    });

    return {
      data: useMemo(
        () => ({
          loading: errorOrLoading,
          task,
          close,
          isOpen: !!taskId && (errorOrLoading ? true : !!task),
          updateTask,
          project,
        }),
        [errorOrLoading, task, close, taskId, updateTask, project],
      ),
    };
  },
);
